//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: '第一时间获取楼盘最新动态'
        }
    }
}
